export const environment = {
  env: 'dev'
};
